/* eslint-disable import/prefer-default-export */
import React, { ReactElement } from 'react';
import { PickerItemHandler } from '../../editor/fields/helpers/editor-fields-helper';
import { ParentRecordState } from '../../record-editor';
import AppLinkPickerItem from './app-link-picker-item';
import {RestApiForm} from "../types";

const ALLOW_MULTIPLE_SELECTION = false;

export const appLinkPickerItemHandler = (): PickerItemHandler => ({
  view: (
    record: Record<string, any>,
    restForm: RestApiForm,
  ): ReactElement => (<AppLinkPickerItem record={record} restForm={restForm} />),
  // @ts-ignore
  selectionHandler: (
    records: Record<string, any>[],
    selectedTaskIDs: any[],
    parentRecordState: ParentRecordState,
  ) => ({
    selectedTaskIDs,
    newParentRecordState: {
      ...parentRecordState,
      allowMultiple: ALLOW_MULTIPLE_SELECTION,
    },
  }),
  recordLinkedTitle: 'Linked Record',
  selectorTitle: 'Select from list',
  allowMultiple: ALLOW_MULTIPLE_SELECTION,
});
